/**
 * リンクありラベルのタブ種別。camelCase / snake_case 両対応。
 */
export function linkTabLabel(item) {
  if (!item) return '';
  if (item.innerLink || item.inner_link) return '（同じタブ）';
  if (item.targetBlank || item.target_blank) return '（別タブ）';
  return '';
}
